import React from "react"
import Image from "next/image"
import Link from "next/link"
import PropTypes from "prop-types"
import styles from "./index.module.scss"

const FullWidthBanner = ({ bannerProps = {} }) => {
  const {
    videoUrl = "",
    media = {},
    showVideo = false,
    showLine = false,
  } = bannerProps || {}

  const imageMedia = { ...media }

  return (
    <div className="full-width-banner">
      <div class="w-full">
        {showVideo
          ? (imageMedia?.fields?.imageUrl ||
              imageMedia.fields?.asset?.fields?.file?.url) && (
              <Link href={videoUrl} target="_blank" class="block">
                <div class="relative w-full">
                  <Image
                    width={100}
                    height={100}
                    src={
                      imageMedia?.fields?.imageUrl ||
                      imageMedia.fields?.asset?.fields?.file?.url
                    }
                    alt={imageMedia?.fields?.altText}
                    class="w-full h-auto object-cover"
                  />
                </div>
              </Link>
            )
          : (imageMedia?.fields?.imageUrl ||
              imageMedia.fields?.asset?.fields?.file?.url) && (
              <div class="relative w-full">
                <Image
                  width={100}
                  height={100}
                  src={
                    imageMedia?.fields?.imageUrl ||
                    imageMedia.fields?.asset?.fields?.file?.url
                  }
                  alt={imageMedia?.fields?.altText}
                  class="w-full h-auto object-cover"
                />
              </div>
            )}
        {showLine && (
          <div className={styles.kohHorizontalruleBlock}>
            <hr className="border-gray-300 flex-grow line" />
          </div>
        )}
      </div>
    </div>
  )
}

FullWidthBanner.propTypes = {
  bannerProps: PropTypes.object,
}

FullWidthBanner.defaultProps = {
  bannerProps: {},
}

export default FullWidthBanner
